import { render, staticRenderFns } from "./AtomPinFitoutButtons.vue?vue&type=template&id=128a629e&"
import script from "./AtomPinFitoutButtons.vue?vue&type=script&lang=js&"
export * from "./AtomPinFitoutButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomButton: require('/app/components/atoms/common/AtomButton.vue').default})
